import HelpCenterSearchTypeAhead from './HelpCenterSearchTypeAhead';

export default HelpCenterSearchTypeAhead;
